export const PsnAlertControllerFactory = ({
  psnAlertService,
}: {
  psnAlertService: IPsnAlertService;
}) => {
  const getPsnAlertList: IGetPsnAlertListController = async (payload) => {
    const response = await psnAlertService.getPsnAlertList(payload);
    return response;
  };

  const getPsnAlertGraphDataList: IGetPsnAlertGraphDataListController = async ({
    clinicId,
    residentIds,
  }) => {
    const response = psnAlertService.getPsnAlertGraphDataList({
      clinicId,
      residentIds,
    });
    return response;
  };

  const getPsnAlertAck: IGetPSNAlertAckController = async ({
    alertId,
    clinicId,
  }) => {
    if (alertId === null) return { success: false };
    const response = await psnAlertService.getPsnAlertAck({
      alertId,
      clinicId,
    });
    return response;
  };

  const addPsnAlertAck: IAddPSNAlertAckController = async ({
    alertId,
    clinicId,
  }) => {
    const response = await psnAlertService.addPsnAlertAck({
      alertId,
      clinicId,
    });
    return response;
  };

  const putPSNv2Review: IPutPSNv2ReviewController = async ({
    clinicId,
    notificationUuid,
  }) => {
    const response = await psnAlertService.putPSNv2Review({
      clinicId,
      notificationUuid,
    });
    return response;
  };

  return {
    getPsnAlertList,
    getPsnAlertGraphDataList,
    getPsnAlertAck,
    addPsnAlertAck,
    putPSNv2Review,
  };
};
